// Enlaces para agregar una sede al calendario. Los usa /calendario/<sede>.
//
// Google y Outlook.com abren su propio formulario de evento ya lleno. Apple y
// cualquier otro calendario usan el .ics de /api/ics.php, que va con dos
// alertas (un dia antes y tres horas antes); los enlaces web no permiten
// fijarlas y usan las del calendario de cada persona.

const SITE = 'https://conferenciaparacanada.com';

// Fecha en UTC basico: 20261006T220000Z
const toUtcBasic = (iso) =>
    new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

const title = (event) => `Conferencia para Canadá en ${event.city}`;

const location = (event) => `${event.venue}, ${event.street}, ${event.city}`;

const details = (event) =>
    'Tu lugar está reservado. Ten a la mano el código QR que recibiste por correo: ' +
    'lo necesitas para entrar y para dejar tus datos a las instituciones.\n\n' +
    `Cronograma de conferencias: ${SITE}/cronograma/${event.slug}`;

export const googleCalendarUrl = (event) =>
    'https://calendar.google.com/calendar/render?' +
    new URLSearchParams({
        action: 'TEMPLATE',
        text: title(event),
        dates: `${toUtcBasic(event.start)}/${toUtcBasic(event.end)}`,
        details: details(event),
        location: location(event),
        ctz: 'America/Mexico_City'
    }).toString();

export const outlookCalendarUrl = (event) =>
    'https://outlook.live.com/calendar/0/action/compose?' +
    new URLSearchParams({
        path: '/calendar/action/compose',
        rru: 'addevent',
        subject: title(event),
        startdt: new Date(event.start).toISOString(),
        enddt: new Date(event.end).toISOString(),
        body: details(event),
        location: location(event)
    }).toString();

export const icsUrl = (event) => `/api/ics.php?sede=${encodeURIComponent(event.slug)}`;
